<div class="holder">
    <div class="card">
        <h1>Başarı ile kaydoldunuz.</h1>
        <h2>Üyeliğinizi aktifleştirmek için lütfen mail adresinizi kontrol edin</h2>
    </div>
</div>
